import {Search} from "history";

export const getUrlSearchParam = (
  searchObj: Search,
  param: string,
): string | null => {
  const urlParams = new URLSearchParams(searchObj);
  return urlParams.get(param);
};
